import React from 'react'
import PropTypes from 'prop-types'


import AddAlert from '@material-ui/icons/AddAlert'

import Snackbar from 'components/Snackbar/Snackbar.jsx'
import { connect } from 'react-redux'

import { closeSnackbar } from 'actions/snackbar'

const SnackbarGlobal = ({ snackbar, ...rest }) => (
  !!snackbar.message && <Snackbar
      {...snackbar}
      close
      icon={AddAlert}
      closeNotification={() => rest.closeSnackbar()}
      place='tr'
    />
)

SnackbarGlobal.propTypes = {
  snackbar: PropTypes.PropTypes.shape({
    message: PropTypes.string,
    fontSize: PropTypes.number
  }).isRequired
};

function mapStateToProps(state) {
  return {
    snackbar: state.snackbar
  };
}

export default connect(mapStateToProps, { closeSnackbar })(SnackbarGlobal);



// WEBPACK FOOTER //
// ./src/layouts/GlobalSnackbar.jsx